import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects'

import { handleError } from 'api/api-utils'
import usersApi from 'api/UsersApi'

import {
  CREATE_USER,
  DELETE_AAD_USER,
  DELETE_USER,
  GET_ALL_USERS,
  GET_USERS,
  INVITE_USER,
  UNLINK_AAD_USER,
  GET_USER,
  GET_USERS_BY_COMPANY,
} from './constants'

import {
  createUserSuccess,
  createUserError,
  deleteAADUserSuccess,
  deleteAADUserError,
  deleteUserSuccess,
  deleteUserError,
  getUsersSuccess,
  getUsersError,
  getAllUsersSuccess,
  getAllUsersError,
  inviteUserError,
  inviteUserSuccess,
  unlinkAADUserSuccess,
  unlinkAADUserError,
  getUserSuccess,
  getUserError,
  setSelectedUser,
  getUsersByCompanySuccess,
  getUsersByCompanyError,
} from './actions'
import { logout, removeAADProfile } from '../App/actions'
import { setApiKey } from 'containers/User/actions'

export function* getUsers(action) {
  try {
    const { companyCode, customerCode, role } = action
    const users = yield call(usersApi.getUsers, {
      companyCode,
      customerCode,
      role,
    })
    yield put(getUsersSuccess(users))
  } catch (error) {
    yield put(handleError(error, getUsersError))
  }
}

export function* getAllusers() {
  try {
    const users = yield call(usersApi.getAllUsers)
    yield put(getAllUsersSuccess(users))
  } catch (error) {
    yield put(handleError(error, getAllUsersError))
  }
}

export function* createUser(action) {
  try {
    const { companyCode, customerCode, user } = action
    const createdUser = yield call(usersApi.createUser, {
      companyCode,
      customerCode,
      user,
    })
    if (createdUser.apiKey) {
      yield put(setApiKey(createdUser.apiKey))
    }
    yield put(createUserSuccess(createdUser))
  } catch (error) {
    yield put(handleError(error, createUserError))
  }
}

export function* deleteUser(action) {
  try {
    const { userId } = action //Finaz id
    const userData = yield call(usersApi.getLoggedInUser)
    yield call(usersApi.deleteUser, { userId })
    yield put(deleteUserSuccess(userId))
    //dispatch logout if user was the current user.
    if (userId === userData.id) yield put(logout())
  } catch (error) {
    yield put(handleError(error, deleteUserError))
  }
}

export function* deleteAADUser(action) {
  try {
    const { userId } = action //AAD id
    const userData = yield call(usersApi.getLoggedInUser)
    yield call(usersApi.deleteAADUser, { userId })
    yield put(deleteAADUserSuccess(userId))
    yield put(removeAADProfile(userId, true))
    //dispatch logout if user was the current user.
    if (userId === userData.id) yield put(logout())
  } catch (error) {
    yield put(handleError(error, deleteAADUserError))
  }
}
export function* inviteUser(action) {
  const { user, email, resend, view, signOut } = action

  try {
    const id = user.id
    yield call(usersApi.inviteUser, {
      userId: id,
      inviteEmail: email,
      resend,
    })

    if (signOut) {
      yield put(logout())
    }

    if (view === 'users') {
      const users = yield call(usersApi.getAllUsers)
      yield put(inviteUserSuccess(users, view))
    }
    if (view === 'user') {
      user.aadUserEmail = email
      yield put(setSelectedUser(user))
      yield put(inviteUserSuccess([], view))
    }
  } catch (error) {
    yield put(handleError(error, inviteUserError, { view }))
  }
}
export function* unlinkAADUser(action) {
  try {
    const { userId, allUsersView } = action
    yield call(usersApi.unlinkAADUser, { userId })
    yield put(unlinkAADUserSuccess(userId, allUsersView))
    yield put(removeAADProfile(userId, false))
    //dispatch logout if user was the current user.
    // if (userId === userData.id) yield put(logout())
  } catch (error) {
    yield put(handleError(error, unlinkAADUserError))
  }
}

export function* getUser(action) {
  try {
    const { userId } = action
    const user = yield call(usersApi.getUser, userId)
    yield put(getUserSuccess(user))
  } catch (error) {
    yield put(handleError(error, getUserError))
  }
}

export function* getUsersByCompany(action) {
  try {
    const { companyCode } = action
    const users = yield call(usersApi.getUsers, { companyCode })
    yield put(getUsersByCompanySuccess({ users, companyCode }))
  } catch (error) {
    yield put(
      handleError(error, getUsersByCompanyError, {
        companyCode: action.companyCode,
        error,
      })
    )
  }
}

export function* usersSaga() {
  yield all([
    takeLatest(GET_USERS, getUsers),
    takeLatest(GET_ALL_USERS, getAllusers),
    takeEvery(CREATE_USER, createUser),
    takeEvery(DELETE_USER, deleteUser),
    takeEvery(DELETE_AAD_USER, deleteAADUser),
    takeEvery(UNLINK_AAD_USER, unlinkAADUser),
    takeEvery(INVITE_USER, inviteUser),
    takeLatest(GET_USER, getUser),
    takeEvery(GET_USERS_BY_COMPANY, getUsersByCompany),
  ])
}

// All sagas to be loaded
export default usersSaga
